const channels = [
  {
    icon: "ri-mail-send-fill",
    name: "私信投稿",
    desc: "不想公开，点我私信小编，悄悄说给你听的人。",
    tag: "保护隐私",
  },
  {
    icon: "ri-message-3-line",
    name: "我想说",
    desc: "心事、吐槽、表白，匿了名写给我，我帮你去讲。",
    tag: "匿名上墙",
  },
  {
    icon: "ri-rocket-2-fill",
    name: "帮我发上墙",
    desc: "信息够劲、瓜够鲜，我就替你火速贴到墙头。",
    tag: "快速过审",
  },
];

export default function EntryStrip() {
  return (
    <section id="entry" className="w-full bg-[#faf8f4]">
      <div className="mx-auto -mt-10 max-w-[1280px] px-4 pb-4 md:px-6">
        <div className="relative z-10 grid gap-3 rounded-3xl border border-red-100 bg-white p-4 shadow-xl shadow-red-900/5 md:grid-cols-3 md:gap-4 md:p-6">
          {channels.map((c) => (
            <a
              key={c.name}
              href="#faq"
              className="group flex items-start gap-4 rounded-2xl border border-transparent p-4 transition hover:border-red-100 hover:bg-red-50/60"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-red-600 text-white transition group-hover:bg-red-700">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-bold text-stone-800">{c.name}</h3>
                  <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700">
                    {c.tag}
                  </span>
                </div>
                <p className="mt-1 text-sm leading-relaxed text-stone-500">{c.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line ml-auto hidden shrink-0 text-2xl text-stone-300 transition group-hover:text-red-500 md:block"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}